import * as React from "react";
import { type SVGProps } from "react";
const SvgPaypal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={38}
    height={26}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={37}
      height={25}
      rx={4.5}
      fill="#fff"
      stroke="#DBE3EB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.748 16.511H9.06a.235.235 0 0 0-.232.198l-.683 4.321a.14.14 0 0 0 .14.162h.806a.235.235 0 0 0 .232-.198l.184-1.165a.234.234 0 0 1 .232-.198h.534c1.113 0 1.755-.537 1.923-1.602.075-.465.003-.831-.216-1.088-.24-.281-.665-.43-1.23-.43Zm.195 1.578c-.092.605-.555.605-1.003.605h-.255l.179-1.13a.14.14 0 0 1 .139-.118h.117c.305 0 .593 0 .741.174.089.103.116.257.082.47Zm4.854-.019h-.809a.14.14 0 0 0-.139.119l-.036.225-.056-.082c-.175-.253-.566-.338-.955-.338-.894 0-1.658.676-1.806 1.623-.078.473.032.925.301 1.24.246.29.6.41 1.019.41.72 0 1.12-.462 1.12-.462l-.037.225a.14.14 0 0 0 .139.162h.729a.234.234 0 0 0 .231-.198l.438-2.762a.14.14 0 0 0-.139-.162Zm-1.127 1.57a.9.9 0 0 1-.913.771c-.235 0-.422-.075-.543-.217-.12-.142-.165-.343-.127-.567a.905.905 0 0 1 .906-.777c.23 0 .417.076.54.22.123.145.172.347.137.57Zm4.622-1.57h.813a.14.14 0 0 1 .115.22l-2.703 3.894a.235.235 0 0 1-.193.1h-.812a.14.14 0 0 1-.115-.221l.842-1.186-.895-2.621a.14.14 0 0 1 .133-.186h.8c.103 0 .194.068.224.167l.475 1.583 1.122-1.647a.236.236 0 0 1 .194-.103Z"
      fill="#253B80"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m28.105 21.03.693-4.4a.141.141 0 0 1 .139-.12h.78a.14.14 0 0 1 .139.163l-.684 4.321a.234.234 0 0 1-.232.198h-.697a.14.14 0 0 1-.138-.162Zm-5.309-4.519h-1.689a.235.235 0 0 0-.232.198l-.683 4.321a.14.14 0 0 0 .14.162h.866c.08 0 .15-.058.162-.138l.194-1.225a.234.234 0 0 1 .231-.198h.535c1.113 0 1.755-.537 1.922-1.602.076-.465.003-.831-.215-1.088-.24-.281-.666-.43-1.23-.43Zm.195 1.578c-.092.605-.555.605-1.003.605h-.255l.18-1.13a.14.14 0 0 1 .138-.118h.117c.305 0 .593 0 .741.174.089.103.116.257.082.47Zm4.854-.02h-.809a.14.14 0 0 0-.139.12l-.035.225-.057-.082c-.175-.253-.566-.338-.955-.338-.894 0-1.657.675-1.806 1.623-.077.473.033.925.301 1.24.247.29.6.41 1.019.41.72 0 1.12-.462 1.12-.462l-.037.224a.14.14 0 0 0 .14.163h.728a.234.234 0 0 0 .232-.198l.437-2.762a.14.14 0 0 0-.14-.162Zm-1.128 1.572a.9.9 0 0 1-.912.77c-.235 0-.423-.075-.543-.217-.12-.142-.165-.343-.127-.567a.905.905 0 0 1 .906-.777c.23 0 .416.076.54.22.123.145.172.347.136.57Z"
      fill="#179BD7"
    />
    <path
      d="m16.998 14.965.207-1.316-.462-.01h-2.209l1.535-9.711a.126.126 0 0 1 .125-.106h3.724c1.236 0 2.09.256 2.535.763.209.237.341.486.406.76.067.286.069.629.003 1.047l-.005.03v.268l.209.118c.176.093.315.2.422.322.18.203.295.461.344.767.05.315.033.69-.05 1.114a3.92 3.92 0 0 1-.457 1.261c-.191.32-.435.586-.724.793a2.945 2.945 0 0 1-.976.439c-.36.093-.77.14-1.22.14h-.29a.875.875 0 0 0-.862.734l-.021.12-.367 2.318-.017.086c-.004.027-.012.04-.023.05a.063.063 0 0 1-.038.013h-1.79Z"
      fill="#253B80"
    />
    <path
      d="M23.265 6.453c-.011.071-.024.143-.038.218-.491 2.516-2.172 3.385-4.317 3.385h-1.093a.53.53 0 0 0-.524.449l-.56 3.54-.158 1.003a.28.28 0 0 0 .276.322h1.938c.23 0 .424-.166.46-.392l.02-.098.364-2.31.024-.127a.465.465 0 0 1 .46-.393h.29c1.877 0 3.347-.76 3.777-2.962.18-.92.086-1.687-.389-2.227a1.85 1.85 0 0 0-.53-.408Z"
      fill="#179BD7"
    />
    <path
      d="M22.75 6.249a3.83 3.83 0 0 0-.477-.106 6.08 6.08 0 0 0-.963-.07H18.39a.464.464 0 0 0-.46.393l-.621 3.924-.018.115a.53.53 0 0 1 .524-.449h1.093c2.146 0 3.826-.87 4.317-3.385.015-.074.027-.147.038-.218a2.619 2.619 0 0 0-.513-.204Z"
      fill="#222D65"
    />
    <path
      d="M17.931 6.466a.463.463 0 0 1 .46-.393h2.92c.345 0 .668.023.962.07a4.427 4.427 0 0 1 .478.106l.11.034c.145.048.28.105.404.17.146-.93-.001-1.563-.505-2.136-.555-.63-1.558-.901-2.84-.901h-3.725a.532.532 0 0 0-.526.449l-1.55 9.81a.32.32 0 0 0 .315.37h2.299l.577-3.655.621-3.924Z"
      fill="#253B80"
    />
  </svg>
);
export default SvgPaypal;
